import axios from 'axios';
import { showAlert } from './alerts';
export const sendMore = async (form, turnstileToken) => {

    if (!turnstileToken || typeof turnstileToken !== "string" || turnstileToken.length > 2048) {
      showAlert('error', 'Please complete the security verification');
      return;
    }
    const email = form.email;
    const refId = form.line;
    const slug = form.slug;
    const type = form.type;
    const phone= form.phone;
    const country= form.country || '';
    const company= form.company || '';
    // const full_phone= form.full_phone;
    // const country= form.country;
const end = type == 'line' ? 'lines' : 'equipments';
// const serverBaseDomain = "http://localhost:3000";
const serverBaseDomain = "https://cserver.zirveextrusion.net";
    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!filter.test(email)) {
            showAlert('error', 'invalid email');
            return;
        }
        if(!phone || phone == ''){
            showAlert('error', 'invalid phone');
            return;
        }
        if(!company || company == ''){
            showAlert('error', 'invalid phone');
            return;
        }
        if(!country || country == ''){
            showAlert('error', 'invalid phone');
            return;
        }
    const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
    try {
      var number = $("#phone").intlTelInput('getNumber');
      var iso = $("#phone").intlTelInput('getSelectedCountryData').iso2;
      // var dialCode = $("#phone").intlTelInput('getSelectedCountryData').dialCode;
      var isValidNumber = intlTelInputUtils.isValidNumber(number, iso);
      var validationError = intlTelInputUtils.getValidationError(number, iso);
      if(!isValidNumber){
        showAlert('error', errorMap[validationError] || 'Please check the phone number');
        return;
      }
      var formattedNumber = intlTelInputUtils.formatNumber(number, iso, intlTelInputUtils.numberFormat.NATIONAL);
      var intNumber = intlTelInputUtils.formatNumber(number, iso, intlTelInputUtils.numberFormat.INTERNATIONAL);
      var e164Number = intlTelInputUtils.formatNumber(number, iso, intlTelInputUtils.numberFormat.E164);
      const dialCode = intNumber.split(' ')[0] || '';
      const nationalPhone = {
        countryCode: iso,
        dialCode: dialCode,
        e164Number: e164Number,
        internationalNumber: intNumber,
        nationalNumber: formattedNumber,
        number: number,
      }
      const res = await axios({
        method: 'POST',
        url: `${serverBaseDomain}/front/api/${end}`, // `http://localhost:3000/front/api/${end}`,
        data: { email, phone ,refId, slug, full_phone: number , country, company, nationalPhone, turnstileToken },
        headers: {
          lang: window.location.pathname.split('/')[1] || 'en'
        }
      });
      if (res.data.status) {
        $("#knowMoreForm")[0].reset();
        window.location = res.data.redirectUrl;
        showAlert('success', res.data.message);
      }
    } catch (err) {
      showAlert('error', err.response.data.message);
    }
  };